import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetLicensesDataSummaryResData } from "./GetLicensesDataSummaryResData";

const ENDPOINT = "/license/summary";

export class GetLicensesDataSummaryCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    public async execute(): Promise<GetLicensesDataSummaryResData> {
        var res = await this.executeCommand();
        return new GetLicensesDataSummaryResData(res);
    }
}
